(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jb-early-start-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jb-early-start-consent')) {
    customElements.define('jb-early-start-consent', class extends HTMLElement {
      static saveQueue = Promise.resolve();
      static saveRevision = 0;

      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.requestInput = this.querySelector('[data-early-start-request]');
        this.acknowledgementInput = this.querySelector('[data-early-start-acknowledgement]');
        this.timeInput = this.querySelector('[data-early-start-time]');
        this.errorElement = this.querySelector('[data-early-start-error]');
        this.statusElement = this.querySelector('[data-early-start-status]');
        this.saveErrorElement = this.querySelector('[data-early-start-save-error]');
        this.saved = this.accepted && this.timeInput.value !== '';
        this.pending = false;
        this.cartChanging = false;
        const options = { signal: this.controller.signal };
        this.addEventListener('change', (event) => {
          if (event.target !== this.requestInput && event.target !== this.acknowledgementInput) return;
          this.timeInput.value = this.accepted ? new Date().toISOString() : '';
          this.updateProof();
          document.querySelectorAll('jb-early-start-consent').forEach((other) => {
            if (other === this || other.dataset.fingerprint !== this.dataset.fingerprint || !other.requestInput) return;
            other.requestInput.checked = this.requestInput.checked;
            other.acknowledgementInput.checked = this.acknowledgementInput.checked;
            other.timeInput.value = this.timeInput.value;
            other.updateProof();
          });
          this.persistConsent();
        }, options);
        this.querySelector('[data-early-start-retry]').addEventListener('click', () => this.persistConsent(), options);
        document.addEventListener('submit', (event) => {
          if (event.target.id !== this.dataset.form) return;
          if (event.submitter && event.submitter.name !== 'checkout') return;
          if (!this.accepted || !this.saved || this.pending) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.errorElement.hidden = this.accepted;
            if (this.accepted) {
              if (!this.pending) this.persistConsent();
              return;
            }
            const missing = this.requestInput.checked ? this.acknowledgementInput : this.requestInput;
            missing.focus();
            missing.reportValidity();
            return;
          }
          this.updateProof();
        }, { ...options, capture: true });
        const resetForQuantityChange = (event) => {
          const quantityChanged = event.target.name === 'updates[]' && event.target.form?.id === this.dataset.form;
          const removeButton = event.type === 'click' ? event.target.closest('cart-remove-button') : null;
          const itemRemoved = removeButton?.closest('form')?.id === this.dataset.form;
          if (!quantityChanged && !itemRemoved) return;
          document.querySelectorAll('jb-early-start-consent').forEach((element) => {
            if (element.dataset.fingerprint !== this.dataset.fingerprint || !element.requestInput) return;
            element.requestInput.checked = false;
            element.acknowledgementInput.checked = false;
            element.requestInput.disabled = true;
            element.acknowledgementInput.disabled = true;
            element.cartChanging = true;
            element.updateProof();
          });
          this.persistConsent();
        };
        document.addEventListener('input', resetForQuantityChange, { ...options, capture: true });
        document.addEventListener('change', resetForQuantityChange, { ...options, capture: true });
        document.addEventListener('click', resetForQuantityChange, { ...options, capture: true });
        this.updateProof();
        queueMicrotask(() => { if (this.isConnected) this.updateProof(); });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      get accepted() {
        return this.requestInput.checked && this.acknowledgementInput.checked;
      }

      persistConsent() {
        const accepted = this.accepted;
        const values = {};
        this.querySelectorAll('input[type="hidden"][name]').forEach((input) => {
          values[input.name.slice(11, -1)] = input.value;
        });
        const fingerprint = this.dataset.fingerprint;
        const revision = ++this.constructor.saveRevision;
        const matching = () => [...document.querySelectorAll('jb-early-start-consent')].filter((element) => element.dataset.fingerprint === fingerprint && element.requestInput);
        matching().forEach((element) => {
          element.saved = false;
          element.pending = true;
          element.saveErrorElement.hidden = true;
          element.statusElement.textContent = element.dataset.savingText;
          element.updateProof();
        });
        const task = this.constructor.saveQueue.catch(() => {}).then(async () => {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: values })
          });
          if (!response.ok) throw new Error('Consent could not be saved');
          const result = await response.json();
          for (const [key, value] of Object.entries(values)) {
            if (String(result.attributes?.[key] ?? '') !== value) throw new Error('Consent storage could not be verified');
          }
        });
        this.constructor.saveQueue = task;
        task.then(() => {
          if (revision !== this.constructor.saveRevision) return;
          matching().forEach((element) => {
            element.pending = false;
            element.saved = accepted && element.accepted;
            element.statusElement.textContent = element.saved ? element.dataset.savedText : '';
            element.updateProof();
          });
        }).catch(() => {
          if (revision !== this.constructor.saveRevision) return;
          matching().forEach((element) => {
            element.pending = false;
            element.saved = false;
            element.statusElement.textContent = '';
            element.saveErrorElement.hidden = false;
            element.updateProof();
          });
        });
      }

      updateProof() {
        const accepted = this.accepted;
        this.querySelectorAll('[data-early-start-proof]').forEach((input) => {
          input.value = accepted ? input.dataset.proofValue : '';
        });
        if (!accepted) this.timeInput.value = '';
        if (accepted) this.errorElement.hidden = true;
        const checkout = document.getElementById(this.dataset.checkout);
        if (checkout) checkout.disabled = !accepted || !this.saved || this.pending || this.cartChanging;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jb-legal-guarantee')) {
    customElements.define('jb-legal-guarantee', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const trigger = this.querySelector('.jb-guarantee__trigger');
        const dialog = this.querySelector('dialog');
        if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
        this.initialized = true;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
        });
        this.querySelector('.jb-guarantee__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('keydown', (event) => event.stopPropagation());
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') event.stopPropagation();
        });
        dialog.addEventListener('close', () => {
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-setup-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jb-setup-gallery')) {
  customElements.define('jb-setup-gallery', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        if (event.target.closest('[data-gallery-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-gallery-next]')) this.show(this.index + 1);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      const viewport = this.querySelector('.jb-gallery__viewport');
      viewport.addEventListener('click', event => {
        if (!this.suppressSelectionClick) return;
        this.suppressSelectionClick = false;
        if (event.detail === 0) return;
        event.preventDefault();
        event.stopPropagation();
      }, options);
      viewport.addEventListener('pointerdown', event => {
        this.suppressSelectionClick = false;
        if (event.pointerType !== 'touch') return;
        this.touch = { x: event.clientX, y: event.clientY };
      }, options);
      viewport.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          this.suppressSelectionClick = true;
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
      }, options);
      viewport.addEventListener('pointercancel', () => { this.touch = null; }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
    show(index) {
      if (!this.slides.length) return;
      const focusedImage = this.querySelector('[data-gallery-select]:focus');
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      if (focusedImage) this.slides[this.index].querySelector('[data-gallery-select]')?.focus({ preventScroll: true });
      this.querySelector('[data-gallery-caption]').textContent = this.slides[this.index].dataset.caption;
      const counter = this.querySelector('[data-gallery-counter]');
      counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      counter.setAttribute('aria-label', this.dataset.progressTemplate.replace('{current}', this.index + 1).replace('{total}', this.slides.length));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
